module.exports = __webpack_public_path__ + "img/40_69_002_200.e63ce2d2.jpg";